import { Directive, ElementRef, HostBinding, HostListener, inject } from '@angular/core';
import {animate, AnimationBuilder, AnimationFactory, AnimationPlayer, style} from '@angular/animations';

@Directive({
    selector: '[appImageFade]',
    standalone: false
})
export class ImageFadeDirective {
    private builder = inject(AnimationBuilder);
    private el = inject(ElementRef);

    @HostBinding('style.visibility')
    visibility = 'hidden';

    private factory: AnimationFactory;
    private player: AnimationPlayer|undefined;

    private previousSrc: string|undefined = undefined;
    private src: string|undefined = undefined;

    constructor() {
        const builder = this.builder;

        this.factory = builder.build([
            style({ opacity: 0 }),
            animate(500, style({ opacity: 1 }))
        ]);

        const observer = new MutationObserver((mutations => {
            mutations.forEach(mutation => {
                const src = (mutation.target as HTMLImageElement).src;

                if (this.src !== undefined) {
                    this.previousSrc = this.src;
                }
                this.src = src;
            });
        }));
        observer.observe(this.el.nativeElement, {attributes: true, attributeFilter: ['src']});
    }

    @HostListener('load')
    onLoad() {
        if (this.player) {
            this.player.destroy();
        }

        const previousSrcURL = this.previousSrc ? new URL(this.previousSrc) : undefined;
        const srcURL = this.src ? new URL(this.src) : undefined;

        this.player = this.factory.create(this.el.nativeElement);
        // Compares the urls by not taking the query parameters in account. This ensures no animation replay when the SAS-url is refreshed.
        if (previousSrcURL !== srcURL && (!previousSrcURL || srcURL && `${previousSrcURL.host}${previousSrcURL.pathname}` !== `${srcURL.host}${srcURL.pathname}`)) {
            this.player.play();
        }
        this.visibility = 'visible';
    }
}
